export const AppFooter = () => (
  <footer className="mt-16 border-t border-slate-200 bg-white" data-testid="app-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
      <p>© {new Date().getFullYear()} RT Vila Nusa Indah 5 Cluster Merak</p>
      <p>Bersama menjaga lingkungan yang aman, bersih, dan hijau.</p>
    </div>
  </footer>
);
